import ActionTypes from "../../store/actionTypes";
import { useCentralStore } from "../../store/appContext";
import { isEmpty } from "../../utils/functionUtils";
import Header from "../../components/common/header/header";
import LandingPage from "../../components/landing/landingPage";
import resources from "../../components/common/resources.json";
import MainContainer from "../MainContainer/MainContainer";

const Dashboard = () => {
  const [
    {
      userDetails,
      FavouriteList,
      projectName,
      carrierThemeData
    },
    dispatch,
  ] = useCentralStore();

  const { theme } = carrierThemeData;

  return (
    // <div className={`w-full ${isEmpty(projectName) ? ' min-h-screen bg-app-starhubGreen starhubBackgroundImg' : 'min-h-screen'}`}
    <div className={`w-[full] mx-auto`}
    // style={{ 
    //   background: isEmpty(projectName) ? `${theme?.colors?.primary} url(${theme?.backgroundImg})` : 'white'
    //  }}
    >
      {/* {!isEmpty(projectName) && ( */}
        <>
        <Header
          className=""
          userDetails={userDetails}
          FavouriteList={FavouriteList}
          resources={resources}
        />
        <hr style={{
          margin: '4px 0 0',
          backgroundColor: 'gray',//theme?.colors?.primary,
          height: '1px',
        }} />
        </>
      {/* // )} */}
      {/* <div className=" w-[85%] mx-auto"> */}
    <div className=" w-full">
      {isEmpty(projectName) && (
        <LandingPage
          ActionTypes={ActionTypes}
          dispatch={dispatch}
          resources={resources}
        />
        // <SiteMapDashboard/>
      )}
      {/* {['Real Time Service Request Report', 'Customer Service SLA Report', 'Technical Service SLA Report', 'Program Summary', 'Finance Reconciliation & Invoice', 'Download Reports', 'Customer Value Management']?.includes(projectName) && ( */}
      {!isEmpty(projectName) && (
          <>
            <MainContainer />
          </>
      )}
      </div>
    </div>
  );
};

export default Dashboard;
